// src/ResetPasswordErrorScreen.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';

export default function ResetPasswordErrorScreen() {
  const navigate = useNavigate();

  return (
    <div style={styles.wrapper}>
      {/* Cabeçalho com logo */}
      <div style={styles.header}>
        <img
          src={process.env.PUBLIC_URL + '/ic_target.png'}
          alt="SPX Logo"
          style={styles.logo}
        />
      </div>

      {/* Parte branca com conteúdo */}
      <div style={styles.container}>
        <h2 style={styles.title}>Redefinir Senha</h2>

        <div style={styles.errorBox}>
          <XCircle color="#E53935" size={40} />
          <p style={styles.errorText}>
            Não foi possível redefinir sua senha. Tente novamente!
          </p>
        </div>

        <button style={styles.button} onClick={() => navigate('/')}>
          Entrar
        </button>
      </div>
    </div>
  );
}

/// 🎨 Ajuste nos estilos
const styles = {
  wrapper: {
    minHeight: '100vh',
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  header: {
    width: '100%',
    backgroundColor: '#EE4D2D',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: 16,
    paddingBottom: 12,
    position: 'relative',
  },
  logo: {
    height: 64,
    objectFit: 'contain',
  },
  container: {
    width: '100%',
    maxWidth: 400,
    backgroundColor: '#fff',
    padding: '24px',
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
    marginTop: -16, // igual ao success
    boxShadow: '0 -2px 8px rgba(0,0,0,0.1)', // adiciona a sombra suave
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#000',
    marginBottom: 48,
  },
  errorBox: {
    width: '100%',
    backgroundColor: '#FFEBEE',
    border: '1px solid #E57373',
    borderRadius: 8,
    padding: 24,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: 48,
  },
  errorText: {
    fontSize: 16,
    color: '#C62828',
    textAlign: 'center',
    marginTop: 8,
  },
  button: {
    backgroundColor: '#EE4D2D',
    color: '#fff',
    border: 'none',
    borderRadius: 8,
    padding: '12px 16px',
    fontSize: 16,
    fontWeight: 'bold',
    cursor: 'pointer',
    width: '100%',
    maxWidth: 350,
  },
};
